import { MonetateExperience } from '@JohnLewisPartnership/experiments-utils';
import Cookies from 'js-cookie';

export const getFlagsFromCookies = (flagNames: Array<string> = []): FeatureFlag[] =>
    flagNames.map((flagName) => {
        return {
            name: flagName,
            isActive: Cookies.get(flagName)?.toLocaleLowerCase() == 'true',
        } as FeatureFlag;
    });

export const isFlagSet = (flagName: string, experiences?: MonetateExperience[]): boolean => {
    const flags = getFlagsFromCookies([flagName]);
    const windowExperiences = getExperiencesFromWindow();

    const isEnabledByCookie = flags.length > 0 ? flags[0].isActive : false;
    const isEnabledByExperimentParam = getFlagFromMonetateExperiences(flagName, experiences);
    const isEnabledByWindowExperience = getFlagFromMonetateExperiences(flagName, windowExperiences);

    return isEnabledByCookie || isEnabledByExperimentParam || isEnabledByWindowExperience;
};

export const getFlagFromMonetateExperiences = (flagName: string, experiences?: MonetateExperience[]): boolean => {
    return (
        experiences?.some((experience) => {
            return experience.parameters && experience.parameters[flagName] === 'true';
        }) || false
    );
};

export const getExperiencesFromWindow = (): MonetateExperience[] => {
    const pageExperiences = window?.jlData?.monetateServer?.persistedExperiences || [];
    return pageExperiences.map((pageExperience) => {
        return {
            experienceName: pageExperience.key,
            id: pageExperience.experienceId,
            variantLabel: pageExperience.split,
            parameters: pageExperience.parameters,
            impressionId: pageExperience.impressionId,
        };
    });
};
